<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados do Item</mat-panel-title>
            </mat-expansion-panel-header>

            <form #formCadastro="ngForm">

                <!-- DADOS INICIAIS -->
                <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>

                    <!-- MATERIAL -->
                    <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                        <mat-label>Material:</mat-label>
                        <mat-select [(ngModel)]="itensPedidosMateriais.material.id" name="material">
                            <mat-option *ngFor="let i of materiais" [value]=i.id>
                                {{i.nome}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="materiais?.length === 0" align="start">Nenhum material
                            cadastrada</mat-hint>
                    </mat-form-field>

                    <!-- QUANTIDADE -->
                    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
                        <input [(ngModel)]="itensPedidosMateriais.qtdPedido" matInput type="number"
                            min="0" name="quantidadeMaterial" placeholder="Quantidade:">
                    </mat-form-field>

                </div>


            </form>

            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                    fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                    fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Itens ( {{listaItensPedidosMateriais?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="material">
                    <th mat-header-cell *matHeaderCellDef> Material </th>
                    <td mat-cell *matCellDef="let element"> {{ element.material?.nome }} </td>
                </ng-container>
                
                <ng-container matColumnDef="quantidade">
                    <th mat-header-cell *matHeaderCellDef> Quantidade de Material </th>
                    <td mat-cell *matCellDef="let element"> {{ element.qtdPedido }} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-button (click)="atualizarRegistro(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar novo item" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>
